module.exports = __webpack_public_path__ + "img/step_3.bfba98a0.png";